import { createTheme } from "@mui/material/styles";

import { getColor } from "@hooks/useColors";
import background_light from "@public/about_us/flares_general_light.png";

import { fontsTheme } from "./fontsTheme";

const initLightTheme = createTheme(fontsTheme, { palette: { mode: "light" } });

export const lightTheme = createTheme(initLightTheme, {
  palette: {
    mode: "light",
    background: {
      default: getColor(c => c.tokens.bg["weak-50"], initLightTheme),
      paper: getColor(c => c.tokens.bg["weak-50"], initLightTheme),
    },
    text: {
      primary: getColor(c => c.tokens.text["strong-950"], initLightTheme),
      secondary: "#909090",
    },
    primary: {
      main: "#282828",
    },
  },
  footerBackgroundGradient:
    "radial-gradient(44.06% 50% at 50% 0%, rgba(5, 223, 84, 0.08) 0%, rgba(150, 197, 240, 0.04) 100%)",
  mainContentGradient: "linear-gradient(82deg, #05DF54 0%, #96C5F0 76%)",
  headerLinearGradient: getColor(
    c => c.gradients.headerlinearlight,
    initLightTheme,
  ),
  background: {
    image: background_light,
  },
  portfolio: {
    header: {
      borderColor_100: getColor(c => c.foundations.blue[100], initLightTheme),
      borderColor_200: getColor(c => c.foundations.blue[200], initLightTheme),
      borderColor_300: getColor(c => c.foundations.blue[300], initLightTheme),
    },
  },
});
